import { Renewal } from "@covertree/agent-portal-graphql";

export function mapRenewalUwReviewToDescription(
  renewal?: Pick<Renewal, "description" | "underwritingReviewReasons">
) {
  const items: string[] = [];
  if (!renewal) return items;
  if (renewal?.description) {
    items.push(renewal.description);
  }
  if (
    renewal.underwritingReviewReasons &&
    renewal.underwritingReviewReasons.length > 0 &&
    !(
      renewal.underwritingReviewReasons.length === 1 &&
      renewal.underwritingReviewReasons[0] === "Accepted"
    )
  ) {
    items.push(
      ...(renewal.underwritingReviewReasons.filter(Boolean) as string[])
    );
  }
  return items;
}
